import React, { useState } from "react";
import ReactMarkdown from "react-markdown";
import rehypeHighlight from "rehype-highlight";
import "highlight.js/styles/github.css";
import { FiCheck, FiCopy } from "react-icons/fi";
import { TbGalaxy } from "react-icons/tb";

const InnerAiMex = ({ text }) => {
    const [copiedIndex, setCopiedIndex] = useState(null);

    const copyFullMessage = async () => {
        try {
            await navigator.clipboard.writeText(text);
            setCopiedIndex("full");
            setTimeout(() => setCopiedIndex(null), 3000);
        } catch (err) {
            console.error("Failed to copy full message: ", err);
        }
    };

    const copyToClipboard = async (code, index) => {
        try {
            await navigator.clipboard.writeText(code);
            setCopiedIndex(index);
            setTimeout(() => setCopiedIndex(null), 3000);
        } catch (err) {
            console.error("Failed to copy text: ", err);
        }
    };

    if (text === "Loading_message") {
        return (
            <div className="loading_mex_ai">
                <div className="loading_mex_ai_icon">
                    <p className="loading_logo_erioon_icon">
                        <i><TbGalaxy /></i>
                    </p>
                </div>
                <div className="loading_beam_ai_cont">
                    <div className="loading_beam"></div>
                    <div className="loading_beam"></div>
                </div>
            </div>
        );
    }

    // This will extract code text from within the markdown
    const extractTextFromChildren = (children) => {
        if (typeof children === "string") return children;
        if (Array.isArray(children)) {
            return children.map(extractTextFromChildren).join("");
        }
        if (typeof children === "object" && children?.props?.children) {
            return extractTextFromChildren(children.props.children);
        }
        return "";
    };

    let blockCounter = 0;

    // Determine if the code block is inline or block-level
    const isBlockCode = (children) => {
        const codeText = extractTextFromChildren(children);
        return codeText.startsWith("```") && codeText.endsWith("```");
    };

    return (
        <div className="inner_ai_mex_cont">
            <ReactMarkdown
                rehypePlugins={[rehypeHighlight]} // Only apply syntax highlighting here
                components={{
                    h1: ({ node, ...props }) => <h1 className="heading1" {...props} />,
                    h2: ({ node, ...props }) => <h2 className="heading2" {...props} />,
                    h3: ({ node, ...props }) => <h3 className="heading3" {...props} />,
                    code({ node, className, children, ...props }) {
                        const codeText = extractTextFromChildren(children);
                        const currentIndex = blockCounter++;
                        const isHighlighted = className != undefined;

                        if (isHighlighted) {
                            return (
                                <pre className="code_block_wrapper w-full">
                                    <div className="code_block_header">
                                        <button
                                            className="copy_code_btn_snippet"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                copyToClipboard(codeText, currentIndex);
                                            }}
                                        >
                                            {copiedIndex === currentIndex ? <FiCheck /> : <FiCopy />}
                                        </button>
                                    </div>
                                    <code className={`code_block w-full ${className ?? ""}`} {...props}>
                                        {children}
                                    </code>
                                </pre>
                            );
                        } else {
                            return (
                                <p className="inline_code_snippet" {...props}>
                                    {children}
                                </p>
                            );
                        }
                    }
                }}
            >
                {text}
            </ReactMarkdown>
            <div className="footer_inner_ai_mex" onClick={copyFullMessage}>
                <i>{copiedIndex === "full" ? <FiCheck /> : <FiCopy />}</i>
            </div>
        </div>
    );
};

export default InnerAiMex;
